module.exports = __webpack_public_path__ + "img/V3.ca98d7f5.png";